<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="factorys"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工厂编号">
            <el-input v-model.trim="filter.factoryNo" placeholder="请输入工厂编号" clearable/>
          </el-form-item>
          <el-form-item label="工厂名称">
            <el-input v-model.trim="filter.factoryName" placeholder="请输入工厂名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <factory-edit ref="factoryEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import FactoryEdit from "./FactoryEdit";
  export default {
    components: { viewTable, FactoryEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(669),
          editAuth: this.$auth(670),
          delAuth: this.$auth(671),
        },
        filter: {
          factoryNo: "",
          factoryName: "",
        },
        columnsProperty: [
          {
            key: "factoryNo",
            width: 100,
            align: "center",
          },
          {
            key: "factoryName",
            minWidth: 150,
          },
          {
            key: "address",
            minWidth: 150,
          },
          {
            key: "shortName",
            width: 160,
          },
          {
            key: "creatorName",
            width: 90,
            align: "center",
          },
          {
            tooltip: true,
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
          },
        ],
      };
    },
    methods: {
      // 查询工厂列表
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新建 编辑
      addEditHandle(row) {
        this.$refs.factoryEdit.open(row);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "factorys", row.pkId).then((resp) => {
          if (resp.success) {
            this.$message.success("删除成功");
            this.loadData();
          }
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
